import { ValueFormatterParams } from "ag-grid-community";
import moment from "moment";
import dayjs from "dayjs";
import { dateFormat, dateTimeFormatForBE } from "components/Utils/dayjsUtils";

export const decimalNumberFormatter =
  (digits = 1) =>
  (params: ValueFormatterParams) => {
    return params.value.toFixed(digits);
  };

export const dateFormatter = (params: ValueFormatterParams) =>
  params.value ? dayjs(params.value).format(dateFormat) : "-";

export const formatCurrency = (
  value: number | string | null | undefined,
  minDigits: number = 2,
  maxDigits: number = 2
): string => {
  if (value === null || value === undefined) return "";

  const num = Number(value);
  if (isNaN(num)) return String(value);

  return num.toLocaleString("en-US", {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
    useGrouping: true,
  });
};

export const currencyFormatter =
  (minDigits: number = 2, maxDigits: number = 2) =>
  (params: ValueFormatterParams) => {
    return formatCurrency(params?.value, minDigits, maxDigits);
  };

export const currencyBGNFormatter =
  (minDigits: number = 2, maxDigits: number = 2) =>
  (params: ValueFormatterParams) =>
    `${formatCurrency(params?.value, minDigits, maxDigits)} €`;

export const dateTimeFormatter = (params: ValueFormatterParams, format = dateTimeFormatForBE) => {
  if (!params?.value) return "-";

  return moment(new Date(params.value)).format(format);
}
